<h1 class="d-hidden">Campus Map</h1>

<ng-template #searchResults let-r="result" let-t="term">
  <ngb-highlight [result]="r.NAME+(r.ABBREV ? ' ('+r.ABBREV+')' : '')" [term]="t"></ngb-highlight>
  <br><ngb-highlight *ngIf="r.OFFICIAL_ROOM_NAME" [result]="r.OFFICIAL_ROOM_NAME" [term]="t"></ngb-highlight>
</ng-template>

<app-announcement></app-announcement>

<mat-drawer-container class="container-fluid" autosize>
  <mat-drawer #drawer class="sidenav" mode="side" role="complementary" aria-label="Map layers">
    <div class="side-nav-head">
      <div class="col col-auto d-flex align-items-center">
        <h2>Layers</h2>
      </div>
      <div class="col col-auto">
        <button mat-icon-button (click)="drawer.toggle()" class="float-right x-button"
          aria-label="Close the Layers Panel">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div class="button-wrapper">
      <button type="button" class="btn btn-outline-primary btn-block" (click)="this.clearAllLayers()">
        Clear All Layers
      </button>
    </div>

    <div class="accordion p-2 pb-5" id="layersAccordion">
      <div *ngFor="let layerGroup of layerGroups; let i = index; first as isFirst" class="mt-2">
        <button type="button" class="layer-group-button d-flex justify-content-between" data-toggle="collapse"
          [attr.data-target]="'#collapse_' + i" aria-expanded="false" [attr.aria-controls]="'collapse_' + i"
          [attr.aria-expanded]="isFirst ? 'true' : 'false'" [class.collapsed]="!isFirst" [id]="'heading_' + i">
          <div class="col p-0 m-0">
            <h3 class="row g-0">
              <div class="col col-2">
                <i [class]="'far '+layerGroup.ICON" [style]="'color:#00285e'" aria-hidden="true"></i>
              </div>
              <div class="col p-0 m-0">
                {{layerGroup.TITLE}}
              </div>
            </h3>
          </div>
          <div class="col col-auto">
            <i class="fa-solid fa-chevron-down chev fa-lg" aria-hidden="true"></i>
          </div>

        </button>
        <div [attr.id]="'collapse_' + i" [class]="'collapse ' + (isFirst ? 'show' : '')" role="region"
          [attr.aria-labelledby]="'heading_' + i">
          <div class="card-body pt-0 pb-0" role="group">
            <div class="row" *ngFor="let layer of layerGroup.LAYERS;">
              <div class="col">
                <div class="row mb-1 pl-3 pe-2">
                  <mat-checkbox color="primary" [checked]="layer.CHECKED" (change)="toggleLayer(layer)">
                    <div class="d-flex">
                      <div class="col col-auto d-flex align-items-center p-0 pr-2">
                        <span class="fa-stack" role="img" aria-hidden="true">
                          <i class="fas fa-circle fa-stack-2x" [style]="'color: #' + layer.PRIMARY_HEX"></i>
                          <i [class]="'fas fa-stack-1x ' + layer.ICON "
                            [style.color]="this.a11y.getAccessibleColor('#' + layer.PRIMARY_HEX)"></i>
                        </span>
                      </div>
                      <div class="col d-flex align-items-center p-0">
                        {{layer.NAME}}
                      </div>
                    </div>
                  </mat-checkbox>
                </div>
                <div class="row" *ngIf="layer.LEGEND && layer.CHECKED">
                  <div class="col-2" role="span"></div>
                  <div class="col" [innerHtml]="sanitizer.bypassSecurityTrustHtml(layer.LEGEND)">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-drawer>
  <div class="sidenav-content container-fluid" role="main">
    <div class="container-fluid">
      <div class="navbar" id="navbar" role="navigation">
        <div class="container-fluid" role="navigation">
          <button class="float-left x-button" mat-icon-button (click)="drawer.toggle()" style="margin-left:10px">
            <mat-icon>menu</mat-icon>
          </button>
          <div class="col" role="search">
            <div class="search-bar">
              <i class="fa-regular fa-magnifying-glass fa-lg" aria-hidden="true"></i>

              <input #searchInput id="typeahead-basic" type="search" placeholder="Search..." [(ngModel)]="searchText"
                [ngbTypeahead]="search" [resultTemplate]="searchResults" [inputFormatter]="searchInputFormatter"
                (selectItem)="handleSearchResults($event)" aria-label="Search campus locations" />

              <button type="button" class="down-arrow-btn" aria-label="Open building list (browse all)" (click)="onBrowseAll()">
                <i class="fa-regular fa-chevron-down fa-lg" aria-hidden="true"></i>
              </button>

              <div class="visually-hidden" id="search-hint">
                Type to search. Use up and down arrows to navigate, Enter to select.
              </div>
            </div>

          </div>
          <img class="float-right mr-2 ml-2" width="40" alt="UF Logo" src="assets/uf.png" style="padding-right:10px" />
        </div>
      </div>

      <button class="visually-hidden-focusable" (click)="focusZoomIn($event)">
        Skip to map controls
      </button>



      <div id="map" #map leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)" role="application">
      </div>

      <a class="issue-button" href="https://bats.businessaffairs.ufl.edu/bili/portal/new/356" target="_blank">Report a Problem <i class="fas fa-arrow-up-right-from-square"></i></a>

    </div>
  </div>
</mat-drawer-container>

<router-outlet></router-outlet>